// extracted by mini-css-extract-plugin
export var layoutContainer = "_b2-0";
export var layoutContainerNoRounding = "_b2-6";
export var layoutContainerOpen = "_b2-5";
export var layoutContainerResizing = "_b2-1";
export var mainContent = "_b2-2";
export var resizeDivider = "_b2-3";
export var slidePanel = "_b2-4";